























































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {get} from "@/context/context";
import {FileService} from "@/services/FileService";
import UploadType from "@/utils/FileUploadType";
import API from "@/utils/Api";
import {Servers} from "@/serverConfig";

@Component
export default class UploadFile extends Vue {
  private fileService: FileService = get('fileService');
  private api: API = get('api');

  private isSelecting:boolean = false;
  private accept:string = 'image/*';
  private fileType:string = 'image';
  private fileUrl:string|boolean = false;

  $refs!: {
    uploader: HTMLFormElement
  }
  @Prop()
  private label?: string;

  @Prop()
  private name?: string;

  @Prop({default: 'primary'})
  private color!: string;

  @Prop({default: 'rgba(198, 171, 224, 0.5)'})
  private dragColor!: string;

  @Prop({default: 'Upload'})
  private buttonText!: string;

  @Prop({default: false})
  private dragAndDrop!: boolean;

  @Prop({default: false})
  private dark!: boolean;

  @Prop({default: '100'})
  private height!: string;

  //image, video, audio
  @Prop({default: 'image'})
  private type!: string;

  //image, audio, video, avatar, music
  @Prop({default: UploadType.IMAGE})
  private uploadType!: string;

  @Prop({default: false})
  private preview!: boolean;

  @Prop({default: false})
  private custom?: boolean;

  @Prop({default: false})
  private multiple?: boolean;

  @Watch('type')
  watchType() {
    this.fileType = this.type;
    this.accept = this.type+'/*';
  }

  private mounted() {
    if (this.uploadType === UploadType.AVATAR) {
      this.fileType = UploadType.IMAGE
    } else if (this.uploadType === UploadType.MUSIC) {
      this.fileType = UploadType.AUDIO
    } else {
      this.fileType = this.uploadType;
    }
    this.accept = this.fileType+'/*';
  }

  private onButtonClick() {
    this.isSelecting = true
    window.addEventListener('focus', () => {
      this.isSelecting = false
    }, { once: true })

    this.$refs.uploader.click()
  }

  private async onFileChanged(e: any) {
    let files = e.target.files ? e.target.files : e.dataTransfer.files;
    if (this.custom) {
      this.$emit('customUpload', files);
    } else {
      if (this.multiple) {
        await this.multiUploadFiles(files);
      } else {
        await this.singleUploadFiles(files[0]);
      }
    }

  }

  private async multiUploadFiles(files: Array<File>) {
    let fileData = null;
    for (const index in files) {
      await this.singleUploadFiles(files[index]);
    }
  }

  private async singleUploadFiles(file: File) {
    this.fileUrl = URL.createObjectURL(file);
    this.api.changeServer(Servers.BACK);

    try {
      let fileData = null;
      switch (this.uploadType) {
        case (UploadType.IMAGE): {
          fileData = await this.fileService.uploadImage({file: file});
          break;
        }
        case (UploadType.AVATAR): {
          fileData = await this.fileService.uploadAvatar({file: file});
          break;
        }
        case (UploadType.VIDEO): {
          fileData = await this.fileService.uploadVideo({file: file});
          break;
        }
        case (UploadType.AUDIO): {
          fileData = await this.fileService.uploadAudio({file: file});
          break;
        }
        default: {fileData = null;}
      }

      if (fileData) {
        this.$emit('uploaded', {...fileData, name: file.name});
      }

    } catch (e) {
      this.fileUrl = false;
    }
  }

}
